import React, { useEffect, useRef, useState } from "react";
import "./bentoGridsView.css";
import { s3url } from "../utility/constand";

const groups = [[1, 2], [3, 4], [5, 6], [7, 8], [9], [10, 11]];

function BentoGridsView() {
  const sectionRef = useRef(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const node = sectionRef.current;
    if (!node) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        setInView(entry.isIntersecting);
      },
      {
        threshold: 0.2, // fire when ~20% visible
      }
    );

    observer.observe(node);

    return () => {
      observer.unobserve(node);
    };
  }, []);
  return (
    <div className="bento-grid-container" ref={sectionRef}>
      <div className="bento-grid-headings">
        <h6>WHAT WE DO</h6>
        <h2>
          If it's Risky, <span>BeFiSc</span>
          <br className="new-line-about-us" /> will Flag it
        </h2>
        <p>
          Fraud doesn’t announce itself. It slips through the cracks sometimes
          in a document, sometimes in an inbox, sometimes in patterns we fail to
          see. At BeFiSc, we build for that reality: uncovering risks in all
          their forms, so businesses can act with confidence, not guesswork.
        </p>
      </div>
      <div className={`bento-grid-main ${inView ? "bento-animate" : ""}`}>
        {groups.map((nums, i) => (
          <div className="bento-grid-sub" key={i}>
            {nums.map((n) => (
              <img
                loading="lazy"
                alt=""
                key={n}
                src={`${s3url}/bento-img-${n}.png`}
                className="bento-img"
              />
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}

export default BentoGridsView;
